import { CUSTOMER_PROFILE_ENTITY, STORES_ENTITY, USERS_ENTITY } from './EntityName';

/* eslint-disable no-unused-vars */
export enum AppRoutes {
  Home = '/home',
  Dashboard = '/dashboard',
  Users = '/admin/users',
  Faq = '/documitra-content/faqs',
  Advantage = '/documitra-content/advantages',
  HowItWorks = '/documitra-content/how-it-works',
  Reviews = '/documitra-content/reviews',
  PhotomitraAdvantage = '/photomitra/advantages',
  PhotomitraHowItWorks = '/photomitra/how-it-works',
  PhotomitraTakingPhotoStep = '/photomitra/taking-photo-steps',
  PhotomitraFaq = '/photomitra-content/faqs',
  PhotomitraPhotoGuidelines = '/photomitra/photo-guidelines',
  PhotoStorePhotSize = '/photo-store/photo-size',
  PhotoStoreFileType = '/photo-store/file-type',
  PhotoStorePlan = '/photo-store/plans',
  ContactInfo = '/contact/contact-info',
  ContactForm = '/contact/user-info',
  BecomePartnerInfo = '/contact/become-partner-info',
  ApplicationFormServices = '/services',
  ApplicationFormParameters = '/parameters',
  ApplicationFormQuestion = '/questions',
  ApplicationFormStepQuestion = '/form/step-question',
  ApplicationFormPackageServiceAttributes = '/packages/service-attributes',
  ApplicationFormPackageDocuments = '/packages/documents',
  ApplicationFormPackageFeatures = '/packages/features',
  ApplicationFormPackagePlans = '/packages/plans',
  ApplicationFormPackages = '/packages',
  ServiceProcessSteps = '/service-process/process-steps',
  ServiceContentManagement = '/service-process/management',
  ServiceContentManagementNoParams = '/service-process/management/no-params',
  ServiceContentManagementWithParams = '/service-process/management/with-params',
  ServiceProcessFaqManagement = '/service-process/management',
  PackageProcessSteps = '/package-process/process-steps',
  PackageContentManagement = '/package-process/management',
  PackageContentManagementNoParams = '/package-process/management/no-params',
  PackageContentManagementWithParams = '/package-process/management/with-params',
  PackageProcessFaqManagement = '/package-process/management',
  ServiceProcessDetailsProcess = '/service-process/process',
  ServiceProcessSubtitle = '/service-process/process/subtitle',
  ServiceTimeline = '/timeline',
  PackageTimeline = '/package-timeline',
  PackageProcess = '/package-process/process',
  ApplicationForm = '/forms',
  ApplicationFormSteps = '/forms/steps',
  PhotoOrderApplication = '/photo-orders/application',
  PhotoOrderTransaction = '/photo-orders/transaction',
  DocumitraOrderApplication = '/documitra-orders/application',
  DocumitraOrderTransaction = '/documitra-orders/transaction',
  CouponsManagement = '/coupons-management',
  OfferManagement = '/offer-management',
  BannerManagement = '/banner-management',
  ServiceCardsManagement = '/service-cards',
  HomepageServiceCategory = '/service-card-categories',
  HeaderServices = '/header-services',
  PartnerService = '/partner-service',
  BucketManagement = '/bucket-management',
  TermsConditionTerms = '/terms-condition/terms',
  TermsConditionConditions = '/terms-condition/condition',
  AboutPageOurTeam = '/about',
  ServiceBasedFAQ = '/faq',
  ServicePageFAQ = '/service-page-faq',
  RelatedArticle = '/article',
  HomepageArticle = '/homepage-articles',
  NewsManagement = '/news-management',
  TimeLineHeading = '/timeLine',
  TimeLineBody = '/timeLine-body',
  ForgotPassword = '/forgot-password',
  ResetPassword = '/reset-password',
  ChangePassword = '/change-password',
  SignedUpUsers = '/users',
  DocumitraLogs = '/admin/logs',
  RefferalDetails = '/refferal-details',
  RefundRequests = '/refund-requests',
  RejectedOrders = '/documitra-orders/rejected',
  PaymentVouchers = '/payment-vouchers',
  PaymentVoucherReport = '/payment-voucher-report',
  DocumitraOrderReport = '/documitra-reports',
  ContactServiceContentManagement = '/contact-management/service-content',
  ContactPackageContentManagement = '/contact-management/package-content',

  // Remove After Final Work
  StoreStatus = '/store-status',
  Inventory = '/inventory',
  Categories = '/categories',
  Subcategories = '/subcategories',
  defectTypes = '/Defect-Types',
  complainStatus = '/complaint-status',
  locations = '/locations',
  complaintsPage = '/complaints',
  OrderList = '/orderList',
  managerTechnician = '/manager-technician',
  assets = '/assets',
  locationType = '/location-type',

  Stores = '/stores',
  OptionTypes = '/option-types',
  Options = '/options',
  Items = '/items',
  CollectionTypes = '/collection-types',
  Collections = '/collections',
  CollectionVariants = '/collection-buckets',
  Variants = '/variants',
  CustomerProfile = '/customers',
  DeliveryPartners = '/delivery-partners',
  Homepage = '/homepage',
  CategoryPage = '/category-page',
  RecipePage = '/recipe',
  CouponManagement = '/coupons',
  Constant = '/constant',
  RatingAndReview = '/download-reviews',
  RefundsPage = '/refunds',
  KitchenHomePage = '/kitchen-homepage',
  KitchenCategoryPage = '/kitchen-category-page',
  BlogsPage = '/blogs',
  AddOns = '/addons',
  BulkAddOns = '/bulk-addons',
  SalesReport = '/sales-report',
  ServiceSteps = '/service-steps',
  AgentPaymentLedger = '/agent-payment-ledger',
  PendingPaymentVerifications = '/agent-ledger',
  PartnerPortal = '/partner-portal',
  DocumitraPartners = '/partner-portal/documitra-partners',
  PartnerServices = '/partner-portal/partner-services',
  PartnerOrders = '/partner-portal/partner-orders',
  PartnerOrderMembers = '/partner-portal/partner-order-members',
  B2BAffiliateProgram = '/partner-portal/partner-program',
  B2BWithdraw = '/partner-portal/b2b-withdraw',
  B2BWithdrawDetail = '/partner-portal/b2b-withdraw/:id',
  LandingPages = '/landing-pages',
  Seo = '/seo',
}

export const POST_LOGIN_WELCOME_PENDING_KEY = 'documitraPostLoginWelcomePending';
export const POST_LOGIN_DESTINATION_KEY = 'documitraPostLoginDestination';

const entityArray = [
  {
    key: 'item-0',
    entityName: 'Dashboard',
    entityUrl: AppRoutes.Dashboard,
  },
  {
    key: 'item-1',
    entityName: 'Users',
    entityUrl: AppRoutes.Users,
    children: [
      {
        key: 'item-1-1',
        entityName: 'Admin Users',
        entityUrl: AppRoutes.Users,
      },
      {
        key: 'item-1-2',
        entityName: 'Documitra Users',
        entityUrl: AppRoutes.SignedUpUsers,
      },
      {
        key: 'item-1-3',
        entityName: 'Agent Users',
        entityUrl: AppRoutes.DocumitraPartners,
      },
      {
        key: 'item-1-4',
        entityName: 'Partner users',
        entityUrl: AppRoutes.B2BAffiliateProgram,
      },
      {
        key: 'item-1-5',
        entityName: 'User Refferals',
        entityUrl: AppRoutes.RefferalDetails,
      },
      {
        key: 'item-1-6',
        entityName: 'Role Management',
        entityUrl: AppRoutes.BucketManagement,
      },
    ],
  },
  {
    key: 'item-2',
    entityName: 'Documitra Order',
    entityUrl: AppRoutes.DocumitraOrderApplication,
  },

  {
    key: 'item-3',
    entityName: 'Agent Orders',
    entityUrl: AppRoutes.PartnerOrders,
  },

  {
    key: 'item-4',
    entityName: 'Photo Order',
    entityUrl: AppRoutes.PhotoOrderApplication,
  },
  {
    key: 'item-13',
    entityName: 'Enquiry Form',
    entityUrl: AppRoutes.DocumitraPartners,
    children: [
      {
        key: 'item-13-1',
        entityName: 'Partner Enquiry',
        entityUrl: AppRoutes.BecomePartnerInfo,
      },
      {
        key: 'item-13-2',
        entityName: 'Customer Enquiry',
        entityUrl: AppRoutes.ContactForm,
      },

    ],
  },
  {
    key: 'item-5',
    entityName: 'Transactions',
    entityUrl: AppRoutes.DocumitraOrderTransaction,
    children: [
      {
        key: 'item-5-1',
        entityName: 'Photomitra',
        entityUrl: AppRoutes.PhotoOrderTransaction,
      },
      {
        key: 'item-5-2',
        entityName: 'Documitra',
        entityUrl: AppRoutes.DocumitraOrderTransaction,
      },
      {
        key: 'item-5-3',
        entityName: 'Refund Requests',
        entityUrl: AppRoutes.RefundRequests,
      },
      {
        key: 'item-5-4',
        entityName: 'Agent Ledger',
        entityUrl: AppRoutes.PendingPaymentVerifications,
      },
      {
        key: 'item-5-5',
        entityName: 'Partner Withdraw Request',
        entityUrl: AppRoutes.B2BWithdraw,
      },
      {
        key: 'item-5-6',

        entityName: 'Payment Vouchers',
        entityUrl: AppRoutes.PaymentVouchers,
      },
      {
        key: 'item-5-7',
        entityName: 'Rejected Orders',
        entityUrl: AppRoutes.RejectedOrders,
      },
    ],
  },
  {
    key: 'item-6',
    entityName: 'Documitra Reports',
    entityUrl: AppRoutes.DocumitraOrderReport,

  },
  {
    key: 'item-7',
    entityName: 'Coupon Management',
    entityUrl: AppRoutes.CouponsManagement,
  },


  {
    key: 'item-8',
    entityName: 'Home Page',
    entityUrl: AppRoutes.Faq,
    children: [
      {
        key: 'item-8-1',
        entityName: 'Documitra FAQ',
        entityUrl: AppRoutes.Faq,
      },
      {
        key: 'item-8-2',
        entityName: 'Why Documitra',
        entityUrl: AppRoutes.Advantage,
      },
      {
        key: 'item-8-3',
        entityName: 'Reviews',
        entityUrl: AppRoutes.Reviews,
      },
      {
        key: 'item-8-4',
        entityName: 'How It Works',
        entityUrl: AppRoutes.HowItWorks,
      },
      {
        key: 'item-8-5',
        entityName: 'Offer Management',
        entityUrl: AppRoutes.OfferManagement,
      },
      {
        key: 'item-8-6',
        entityName: 'Banner Management',
        entityUrl: AppRoutes.BannerManagement,
      },
      {
        key: 'item-8-7',
        entityName: 'Homepage Articles',
        entityUrl: AppRoutes.HomepageArticle,
      },
      {
        key: 'item-8-8',
        entityName: 'Newsroom Management',
        entityUrl: AppRoutes.NewsManagement,
      },
    ],
  },

  {
    key: 'item-9',
    entityName: 'Photomitra Page',
    entityUrl: AppRoutes.PhotomitraAdvantage,
    children: [
      {
        key: 'item-9-1',
        entityName: 'Why Photomitra ?',
        entityUrl: AppRoutes.PhotomitraAdvantage,
      },
      {
        key: 'item-9-2',
        entityName: 'How It Works',
        entityUrl: AppRoutes.PhotomitraHowItWorks,
      },
      {
        key: 'item-9-3',
        entityName: 'Taking Photo Step',
        entityUrl: AppRoutes.PhotomitraTakingPhotoStep,
      },
      {
        key: 'item-9-4',
        entityName: 'Photomitra FAQ',
        entityUrl: AppRoutes.PhotomitraFaq,
      },
      {
        key: 'item-9-5',
        entityName: 'Photo Guidelines',
        entityUrl: AppRoutes.PhotomitraPhotoGuidelines,
      },
      {
        key: 'item-9-6',
        entityName: 'Photo-Store',
        entityUrl: AppRoutes.PhotoStorePhotSize,
        children: [
          {
            key: 'item-9-6-1',
            entityName: 'Photo Size',
            entityUrl: AppRoutes.PhotoStorePhotSize,
          },
          {
            key: 'item-9-6-2',
            entityName: 'File Type',
            entityUrl: AppRoutes.PhotoStoreFileType,
          },
          {
            key: 'item-9-6-3',
            entityName: 'Plans Page',
            entityUrl: AppRoutes.PhotoStorePlan,
          },

        ],
      },
    ],
  },


  {
    key: 'item-10',
    entityName: 'Services',
    children: [
      {
        key: 'item-10-1',
        entityName: 'Add Services',
        entityUrl: AppRoutes.ApplicationFormServices,
      },

      {
        key: 'item-10-2',
        entityName: 'Service Content',
        entityUrl: AppRoutes.ContactServiceContentManagement,
      },
      {
        key: 'item-10-3',
        entityName: 'Agent Portal Service',
        entityUrl: AppRoutes.PartnerServices,
      },
      {
        key: 'item-10-4',
        entityName: 'Partner Services',
        entityUrl: AppRoutes.PartnerService,
      },

      {
        key: 'item-10-5',
        entityName: 'Services Page',
        entityUrl: AppRoutes.ServiceCardsManagement,
        children: [
          {
            key: 'item-10-5-1',
            entityName: 'Header Services',
            entityUrl: AppRoutes.HeaderServices,
          },
          {
            key: 'item-10-5-2',
            entityName: 'All Services Page',
            entityUrl: AppRoutes.ServiceCardsManagement,
          },
          {
            key: 'item-10-5-3',
            entityName: 'Service Categories',
            entityUrl: AppRoutes.HomepageServiceCategory,
          },
          {
            key: 'item-10-5-4',
            entityName: 'Service Page FAQ',
            entityUrl: AppRoutes.ServicePageFAQ,
          },
        ],
      },
    ],
  },
  {
    key: 'item-11',
    entityName: 'Packages',
    entityUrl: AppRoutes.ApplicationFormPackageServiceAttributes,
    children: [
      {
        key: 'item-11-1',
        entityName: 'Documents',
        entityUrl: AppRoutes.ApplicationFormPackageDocuments,
      },
      {
        key: 'item-11-2',
        entityName: 'Features',
        entityUrl: AppRoutes.ApplicationFormPackageFeatures,
      },
      {
        key: 'item-11-3',
        entityName: 'Packages',
        entityUrl: AppRoutes.ApplicationFormPackages,
      },
      {
        key: 'item-11-4',
        entityName: 'Questions',
        entityUrl: AppRoutes.ApplicationFormQuestion,
      },
      {
        key: 'item-11-5',
        entityName: 'Forms',
        entityUrl: AppRoutes.ApplicationForm,
      },
      {
        key: 'item-11-6',
        entityName: 'Package Content',
        entityUrl: AppRoutes.ContactPackageContentManagement,
      },
    ],
  },


  {
    key: 'item-12',
    entityName: 'External Pages',
    entityUrl: AppRoutes.TermsConditionTerms,
    children: [
      {
        key: 'item-12-1',
        entityName: 'Terms Page',
        entityUrl: AppRoutes.TermsConditionTerms,
      },
      {
        key: 'item-12-2',
        entityName: 'Conditions Page',
        entityUrl: AppRoutes.TermsConditionConditions,
      },
      {
        key: 'item-12-3',
        entityName: 'About Us Team',
        entityUrl: AppRoutes.AboutPageOurTeam,
      },
      {
        key: 'item-12-4',
        entityName: 'Contact Info',
        entityUrl: AppRoutes.ContactInfo,
      },
    ],
  },
  {
    key: 'item-14',
    entityName: 'SEO Management',
    entityUrl: AppRoutes.Seo,
  },

  {
    key: 'item-15',
    entityName: 'Logs & History',
    entityUrl: AppRoutes.DocumitraLogs,
  },

];

type StatusType = { id: string; value: string; name: string }[];

export const statusOption: StatusType = [
  {
    id: '1',
    value: 'Expert review and editing in progress',
    name: 'Expert review and editing in progress',
  },
  { id: '2', value: 'Editing Failed', name: 'Editing Failed' },
  { id: '3', value: 'Printing in progress', name: 'Printing in progress' },
  {
    id: '4',
    value: 'Print order send to studio',
    name: 'Print order send to studio',
  },
  { id: '5', value: 'Completed', name: 'Completed' },
  { id: '6', value: 'initialized', name: 'Initialized' },
  { id: '7', value: 'Processed photo added', name: 'Processed photo added' },
  { id: '8', value: 'Order dispatched', name: 'Order dispatched' },
];

export const documitraApplicationStatusOption: StatusType = [
  // Filter sequence (Documitra Orders) - Application Status filter order
  { id: '1', value: 'Order Pending', name: 'Order Pending' },
  { id: '30', value: 'Payment Pending', name: 'Payment Pending' },
  { id: '2', value: 'Document Pending', name: 'Document Pending' },
  { id: '3', value: 'Document Under Review', name: 'Documents Under Review' },
  { id: '4', value: 'Additional Information Required', name: 'Additional Information Required' },
  { id: '5', value: 'Create Accounts', name: 'Create Accounts' },
  { id: '6', value: 'Fill Form', name: 'Fill Form' },
  { id: '7', value: 'Form Review Pending by applicant', name: 'Form Review Pending by applicant' },
  { id: '8', value: 'Form Reviewed by the user', name: 'Form Reviewed by the user' },
  { id: '9', value: 'Submit Form', name: 'Submit Form' },
  { id: '50', value: 'Send Payment details', name: 'Send Payment details' },
  { id: '10', value: 'Government Fee payment pending', name: 'Government Fee payment pending' },
  { id: '51', value: 'Verify Application', name: 'Verify Application' },
  { id: '11', value: 'VFS Payment', name: 'VFS Payment' },
  { id: '24', value: 'Document Printing', name: 'Document Printing' },
  { id: '15', value: 'Final Email to be sent', name: 'Final Email to be sent' },
  { id: '13', value: 'Notary Pending by user', name: 'Notary Pending by user' },
  { id: '25', value: 'Send VFS steps', name: 'Send VFS steps' },
  { id: '44', value: 'Appointment pending', name: 'Appointment pending' },
  { id: '12', value: 'Application Completed', name: 'Application Completed' },
  // Existing staging/legacy values kept visible so every active order can be filtered.
  { id: '31', value: 'Payment Done', name: 'Payment Done' },
  { id: '32', value: 'Payment Successful', name: 'Payment Successful' },
  {
    id: '33',
    value: 'Additional documents uploaded by the user',
    name: 'Additional documents uploaded by the user',
  },
  { id: '34', value: 'Biometrics appointment booked', name: 'Biometrics appointment booked' },
  { id: '35', value: 'Notary pending', name: 'Notary pending' },
  { id: '36', value: 'Refund issued', name: 'Refund issued' },
  { id: '37', value: 'Form filled review pending', name: 'Form filled review pending' },
  { id: '38', value: 'Application Dispatched by VAC', name: 'Application Dispatched by VAC' },
  {
    id: '39',
    value: 'Application under process at Consulate',
    name: 'Application under process at Consulate',
  },
  { id: '40', value: 'Form Review By the USER', name: 'Form Review By the USER' },
  { id: '41', value: 'Form accepted by the user', name: 'Form accepted by the user' },
  { id: '42', value: 'Remarks added by the user', name: 'Remarks added by the user' },
  { id: '43', value: '__NO_APPLICATION_STATUS__', name: 'No Application Status' },
];

export const documitraOfficialApplicationStatusOption: StatusType = [
  { id: '1', value: 'Order Pending', name: 'Order Pending' },
  { id: '2', value: 'Payment Pending', name: 'Payment Pending' },
  { id: '3', value: 'Document Pending', name: 'Document Pending' },
  { id: '4', value: 'Document Under Review', name: 'Documents Under Review' },
  { id: '5', value: 'Additional Information Required', name: 'Additional Information Required' },
  { id: '6', value: 'Create Accounts', name: 'Create Accounts' },
  { id: '7', value: 'Fill Form', name: 'Fill Form' },
  { id: '8', value: 'Form Review Pending by applicant', name: 'Form Review Pending by applicant' },
  { id: '9', value: 'Form Reviewed by the user', name: 'Form Reviewed by the user' },
  { id: '10', value: 'Submit Form', name: 'Submit Form' },
  { id: '11', value: 'Send Payment details', name: 'Send Payment details' },
  { id: '12', value: 'Government Fee payment pending', name: 'Government Fee payment pending' },
  { id: '13', value: 'Verify Application', name: 'Verify Application' },
  { id: '14', value: 'VFS Payment', name: 'VFS Payment' },
  { id: '15', value: 'Document Printing', name: 'Document Printing' },
  { id: '16', value: 'Final Email to be sent', name: 'Final Email to be sent' },
  { id: '17', value: 'Notary Pending by user', name: 'Notary Pending by user' },
  { id: '18', value: 'Send VFS steps', name: 'Send VFS steps' },
  { id: '19', value: 'Appointment pending', name: 'Appointment pending' },
  { id: '20', value: 'Application Completed', name: 'Application Completed' },
];

export const getDocumitraOfficialApplicationStatusOptions = (): StatusType =>
  documitraOfficialApplicationStatusOption;

export const DOCUMITRA_REJECTED_BY_AUTHORITY_STATUS = 'Application Rejected by Authority';

export const documitraGovernmentStatusOption: StatusType = [
  { id: '1', value: 'Acknowledgement Pending', name: 'Acknowledgement Pending' },
  { id: '2', value: 'Biometrics Appointment', name: 'Biometrics Appointment' },
  { id: '3', value: 'Application on Hold', name: 'Application on Hold' },
  { id: '4', value: 'Government Approval Pending', name: 'Government Approval Pending' },
  { id: '5', value: 'Approved by Government', name: 'Approved by Government' },
  {
    id: '6',
    value: DOCUMITRA_REJECTED_BY_AUTHORITY_STATUS,
    name: DOCUMITRA_REJECTED_BY_AUTHORITY_STATUS,
  },
  { id: '7', value: 'Withdrawal by applicant', name: 'Withdrawal by applicant' },
  { id: '8', value: 'Documitra Review Pending', name: 'Documitra Review Pending' },
  { id: '9', value: 'Application Closed', name: 'Application Closed' },
];

export const getDocumitraGovernmentStatusOptions = (): StatusType =>
  documitraGovernmentStatusOption;

export const getDocumitraApplicationStatusFilterOptions = (): StatusType => {
  const paymentStatusValues = new Set([
    'payment pending',
    'payment done',
    'payment successful',
    'refund issued',
  ]);
  const seenStatusValues = new Set<string>();

  return [...documitraOfficialApplicationStatusOption, ...documitraGovernmentStatusOption].reduce(
    (options, option) => {
      const normalizedValue = option.value.trim().toLowerCase();

      if (paymentStatusValues.has(normalizedValue) || seenStatusValues.has(normalizedValue)) {
        return options;
      }

      seenStatusValues.add(normalizedValue);
      options.push({
        ...option,
        id: `application-${options.length + 1}`,
      });

      return options;
    },
    [] as StatusType
  );
};

export const documitraOrderStatusOption: StatusType = [
  // Filter sequence (Documitra Orders) — matches documitra.com workflow
  { id: '1', value: 'Order Pending', name: 'Order Pending' },
  { id: '2', value: 'Document Pending', name: 'Document Pending' },
  { id: '3', value: 'Document under review', name: 'Document under review' },
  { id: '4', value: 'Additional information required', name: 'Additional information required' },
  {
    id: '5',
    value: 'Documents received and under review',
    name: 'Documents received and under review',
  },
  { id: '6', value: 'Form Filling under process', name: 'Form Filling under process' },
  { id: '7', value: 'Form Review Pending by applicant', name: 'Form Review Pending by applicant' },
  { id: '8', value: 'Form reviewed By the USER', name: 'Form reviewed By the USER' },
  { id: '9', value: 'Application ready for submission', name: 'Application ready for submission' },
  { id: '10', value: 'Submit Form', name: 'Submit Form' },
  { id: '11', value: 'Send Payment details', name: 'Send Payment details' },
  { id: '12', value: 'Government fee payment pending', name: 'Government fee payment pending' },
  { id: '13', value: 'Verify Application', name: 'Verify Application' },
  { id: '14', value: 'Government fee paid by user', name: 'Government fee paid by user' },
  { id: '15', value: 'Final submit', name: 'Final submit' },
  { id: '16', value: 'Notary pending', name: 'Notary pending' },
  { id: '17', value: 'Biometrics appointment booked', name: 'Biometrics appointment booked' },
  {
    id: '18',
    value: 'Package in transit from documitra',
    name: 'Package in transit from documitra',
  },
  { id: '16', value: 'Application under process at VAC', name: 'Application under process at VAC' },
  { id: '17', value: 'Application on hold at VAC', name: 'Application on hold at VAC' },
  {
    id: '18',
    value: 'Application under process at Consulate',
    name: 'Application under process at Consulate',
  },
  { id: '19', value: 'Application Dispatched by VAC', name: 'Application Dispatched by VAC' },
  { id: '20', value: 'Application closed', name: 'Application closed' },
  { id: '21', value: 'Refund issued', name: 'Refund issued' },

  // Keep legacy/edge statuses available (placed after main workflow)
  { id: '22', value: 'Remarks have been added', name: 'Remarks have been added' },
  { id: '23', value: 'Payment Pending', name: 'Payment Pending' },
  { id: '24', value: 'Payment done', name: 'Payment done' },
  { id: '25', value: 'Payment Successful', name: 'Payment Successful' },
  { id: '26', value: 'Application Closed', name: 'Application Closed' },
];

export const partnerOrderStatusOption: StatusType = [
  // Filter sequence (Partner Orders) — matches partner order workflow (no refund status)
  { id: '1', value: 'Order Pending', name: 'Order Pending' },
  { id: '2', value: 'Document Pending', name: 'Document Pending' },
  { id: '3', value: 'Document under review', name: 'Document under review' },
  { id: '4', value: 'Additional information required', name: 'Additional information required' },
  {
    id: '5',
    value: 'Documents received and under review',
    name: 'Documents received and under review',
  },
  { id: '6', value: 'Form filling under process', name: 'Form filling under process' },
  { id: '7', value: 'Form Review Pending by applicant', name: 'Form Review Pending by applicant' },
  { id: '8', value: 'Form reviewed By the USER', name: 'Form reviewed By the USER' },
  { id: '9', value: 'Application ready for submission', name: 'Application ready for submission' },
  // Note: legacy typo exists in partner orders DB ("paymnent")
  { id: '10', value: 'Government fee paymnent pending', name: 'Government fee paymnent pending' },
  { id: '11', value: 'Government fee paid by user', name: 'Government fee paid by user' },
  { id: '12', value: 'Final submit', name: 'Final submit' },
  { id: '13', value: 'Notary pending', name: 'Notary pending' },
  { id: '14', value: 'Biometrics appointment booked', name: 'Biometrics appointment booked' },
  {
    id: '15',
    value: 'Package in transit from documitra',
    name: 'Package in transit from documitra',
  },
  { id: '16', value: 'Application under process at VAC', name: 'Application under process at VAC' },
  { id: '17', value: 'Application on hold at VAC', name: 'Application on hold at VAC' },
  {
    id: '18',
    value: 'Application under process at Consulate',
    name: 'Application under process at Consulate',
  },
  { id: '19', value: 'Application Dispatched by VAC', name: 'Application Dispatched by VAC' },
  { id: '20', value: 'Application closed', name: 'Application closed' },
];

// Partner member status options: Partner Orders only (ordered)
export const partnerMemberStatusOptions: StatusType = partnerOrderStatusOption;

export const documitraOrderStatusOption2: StatusType = [
  {
    id: '1',
    value: 'Additional information required',
    name: 'Additional information required',
  },
  {
    id: '2',
    value: 'Government fee payment pending',
    name: 'Government fee payment pending',
  },
  {
    id: '3',
    value: 'Biometrics appointment booked',
    name: 'Biometrics appointment booked',
  },
  {
    id: '4',
    value: 'Government fee paid by user',
    name: 'Government fee paid by user',
  },
  {
    id: '5',
    value: 'Documents received and under review',
    name: 'Documents received and under review',
  },
  {
    id: '6',
    value: 'Remarks have been added',
    name: 'Remarks have been added',
  },
  { id: '7', value: 'Notary pending', name: 'Notary pending' },
  {
    id: '8',
    value: 'Package in transit from documitra',
    name: 'Package in transit from documitra',
  },
  {
    id: '9',
    value: 'Application ready for submission',
    name: 'Application ready for submission',
  },
  { id: '10', value: 'Final submit', name: 'Final submit' },
  { id: '11', value: 'Application Closed', name: 'Application Closed' },
  {
    id: '12',
    value: 'Form Filling under process',
    name: 'Form Filling under process',
  },
  {
    id: '13',
    value: 'Form Review Pending by applicant',
    name: 'Form Review Pending by applicant',
  },
  {
    id: '15',
    value: 'Form Reviewed By the USER',
    name: 'Form Reviewed By the USER',
  },

  // {
  //   id: '16',
  //   value: 'Payment done',
  //   name: 'Payment done',
  // },
  { id: '17', value: 'Refund issued', name: 'Refund issued' },
];
export const documitraVucketOption: StatusType = [
  { id: '1', value: 'Passport', name: 'Additional information required' },
  {
    id: '2',
    value: 'Government fee payment pending',
    name: 'Government fee payment pending',
  },
  {
    id: '3',
    value: 'Biometrics appointment booked',
    name: 'Biometrics appointment booked',
  },
  {
    id: '4',
    value: 'Government fee paid by user',
    name: 'Government fee paid by user',
  },
  {
    id: '5',
    value: 'Documents received and under review',
    name: 'Documents received and under review',
  },
  {
    id: '6',
    value: 'Remarks have been added',
    name: 'Remarks have been added',
  },
];

export const documitraPaymentStatusOption: StatusType = [
  { id: '1', value: 'Payment Pending', name: 'Payment Pending' },
  { id: '2', value: 'Payment Successful', name: 'Payment Successful' },
  { id: '3', value: 'Payment Done', name: 'Payment Done' },
  { id: '4', value: 'Refund issued', name: 'Refund issued' },
];
export const documitraPaymentStatusFilterOption: StatusType = documitraPaymentStatusOption;
export const documitraManualPaymentStatusOption: StatusType = [
  { id: '1', value: 'Payment Successful', name: 'Payment Successful' },
  { id: '2', value: 'Refund issued', name: 'Refund issued' },
];

export const documitraMemberStatusOption: StatusType = documitraApplicationStatusOption;

const normalizeDocumitraStatus = (status: string): string =>
  status.trim().toLowerCase().replace(/\s+/g, ' ');

const documitraAdminStatusAliases: Record<string, string> = {
  'order pending': 'Order Pending',
  'payment pending': 'Payment Pending',
  'document pending': 'Document Pending',
  'documents pending': 'Document Pending',
  'document under review': 'Documents Under Review',
  'documents under review': 'Documents Under Review',
  'additional information required': 'Additional Information Required',
  'documents received and under review': 'Create Accounts',
  'create accounts': 'Create Accounts',
  'form filling under process': 'Fill Form',
  'fill form': 'Fill Form',
  'form review pending by applicant': 'Form Review Pending by applicant',
  'form reviewed by the user': 'Form Reviewed by the user',
  'application ready for submission': 'Submit Form',
  'submit form': 'Submit Form',
  'send payment details': 'Send Payment details',
  'government fee payment pending': 'Government Fee payment pending',
  'government fee paymnent pending': 'Government Fee payment pending',
  'verify application': 'Verify Application',
  'government fee paid by user': 'VFS Payment',
  'vfs payment': 'VFS Payment',
  'document printing': 'Document Printing',
  'package in transit from documitra': 'Final Email to be sent',
  'final email to be sent': 'Final Email to be sent',
  'notary pending': 'Notary Pending by user',
  'notary pending by user': 'Notary Pending by user',
  'send vfs steps': 'Send VFS steps',
  'final submit': 'Application Completed',
  'application completed': 'Application Completed',
  'acknowledgement pending': 'Acknowledgement Pending',
  'application on hold at vac': 'Application on Hold',
  'application on hold': 'Application on Hold',
  'government approval pending': 'Government Approval Pending',
  'approved by government': 'Approved by Government',
  'appointment pending': 'Appointment pending',
  'biometrics appointment': 'Biometrics Appointment',
  'application rejected by authority': DOCUMITRA_REJECTED_BY_AUTHORITY_STATUS,
  'withdrawal by applicant': 'Withdrawal by applicant',
  'documitra review pending': 'Documitra Review Pending',
  'application closed': 'Application Closed',
};

/** Tag filter for the Documitra Order list (backend query param `memberTag`). */
export const documitraMemberTagFilterOption: StatusType = [
  { id: '1', value: 'rejected-by-authority', name: 'Rejected by Authority' },
  { id: '2', value: 'on-hold', name: 'On Hold' },
];

/** Member tags come from the member flags; legacy rows may still carry the status value. */
export const isDocumitraMemberRejectedByAuthority = (member: any): boolean =>
  !!member?.isRejectedByAuthority || isDocumitraRejectedByAuthorityStatus(member?.status);

export const isDocumitraMemberOnHold = (member: any): boolean => !!member?.isOnHold;

/** "Application Rejected by Authority" gets a red tag in lists and requires a remark. */
export const isDocumitraRejectedByAuthorityStatus = (status?: string): boolean =>
  !!status &&
  normalizeDocumitraStatus(status) ===
  normalizeDocumitraStatus(DOCUMITRA_REJECTED_BY_AUTHORITY_STATUS);

export const getDocumitraAdminStatusValue = (status?: string): string => {
  if (!status || !status.trim()) {
    return '';
  }

  const normalizedStatus = normalizeDocumitraStatus(status);
  return documitraAdminStatusAliases[normalizedStatus] || status.trim();
};

const documitraAutoMemberStatusValues = [
  'Order Pending',
  'Payment Pending',
  'Document Pending',
  'Document Under Review',
  'Documents Under Review',
  'Form Reviewed by the user',
];

const documitraCommonManualMemberStatusValues = [
  'Additional Information Required',
  'Create Accounts',
  'Fill Form',
  'Form Review Pending by applicant',
  'Submit Form',
  'Send Payment details',
  'Government Fee payment pending',
  'Verify Application',
  'Appointment pending',
  'Application Completed',
];

const documitraReadyToShipMemberStatusValues = [
  'Send Payment details',
  'Government Fee payment pending',
  'Verify Application',
  'VFS Payment',
  'Document Printing',
  'Final Email to be sent',
  'Notary Pending by user',
];

const documitraOnlineConsultationMemberStatusValues = ['Send VFS steps', 'Final Email to be sent'];

const optionMatchesStatus = (option: { value: string; name: string }, status?: string) => {
  const adminStatus = getDocumitraAdminStatusValue(status);
  return !!adminStatus && (option.value === adminStatus || option.name === adminStatus);
};

export const getDocumitraMemberStatusOptionsByPlan = (
  planText?: string,
  currentStatus?: string
): StatusType => {
  const normalizedPlan = (planText || '').toLowerCase();
  const isReadyToShip = normalizedPlan.includes('ready to ship');
  const isOnlineConsultation = normalizedPlan.includes('online consultation');

  const allowedStatusValues = new Set([
    ...documitraCommonManualMemberStatusValues,
    ...(isReadyToShip ? documitraReadyToShipMemberStatusValues : []),
    ...(isOnlineConsultation ? documitraOnlineConsultationMemberStatusValues : []),
  ]);

  const shouldFilterByPlan = isReadyToShip || isOnlineConsultation;

  return getDocumitraOfficialApplicationStatusOptions().filter(option => {
    if (optionMatchesStatus(option, currentStatus)) {
      return true;
    }

    if (documitraAutoMemberStatusValues.includes(option.value)) {
      return false;
    }

    if (!shouldFilterByPlan) {
      return true;
    }

    return allowedStatusValues.has(option.value);
  });
};

export { entityArray };

export const routesEntityArray = [USERS_ENTITY, CUSTOMER_PROFILE_ENTITY, STORES_ENTITY];

export const STORE_NESTED_URL_MAPPING = {
  STORE_DASHBAORD: 'dashboard',
  STORE_INVENTORY: 'store-inventory',
  PROCESSED_PHOTO: 'items',
  STORE_VARAINT: 'store-variant',
  STORE_ADD_ONS: 'store-add-ons',
  STORE_BULK_ADD_ONS: 'store-bulk-add-ons',
  STORE_SLOTS: 'slots',
};

export const storeNestedUrlArray = [
  STORE_NESTED_URL_MAPPING.STORE_DASHBAORD,
  STORE_NESTED_URL_MAPPING.STORE_INVENTORY,
  STORE_NESTED_URL_MAPPING.PROCESSED_PHOTO,
  STORE_NESTED_URL_MAPPING.STORE_VARAINT,
  STORE_NESTED_URL_MAPPING.STORE_ADD_ONS,
  STORE_NESTED_URL_MAPPING.STORE_BULK_ADD_ONS,
  STORE_NESTED_URL_MAPPING.STORE_SLOTS,
];

export const inputTypesOptions: any = [
  {
    id: '1',
    value: 'text',
    name: 'Text',
    validations: [
      { type: 'required', name: 'Required', errorMessage: '' },
      {
        type: 'length',
        name: 'Text length',
        value: '',
        placeholder: 'Enter required length',
        errorMessage: '',
      },
      {
        type: 'min',
        name: 'Min text length',
        value: '',
        placeholder: 'Enter minimum required length',
        errorMessage: '',
      },
      {
        type: 'max',
        name: 'Max text length',
        value: '',
        placeholder: 'Enter maximum required length',
        errorMessage: '',
      },
      {
        type: 'matches',
        name: 'Matches pattern',
        value: '',
        placeholder: 'Enter regex pattern',
        errorMessage: '',
      },
      { type: 'url', name: 'Ensure URL', errorMessage: '' },
      { type: 'uuid', name: 'Ensure UUID', errorMessage: '' },
      { type: 'trim', name: 'Ensure Trimmed', errorMessage: '' },
      { type: 'lowercase', name: 'Ensure Lowercase', errorMessage: '' },
      { type: 'uppercase', name: 'Ensure Uppercase', errorMessage: '' },
    ],
  },
  {
    id: '2',
    value: 'number',
    name: 'Number',
    validations: [
      { type: 'required', name: 'Required', errorMessage: '' },
      {
        type: 'min',
        name: 'Minimum Number',
        value: '',
        placeholder: 'Enter required minimum number',
        errorMessage: '',
      },
      {
        type: 'max',
        name: 'Maximum Number',
        value: '',
        placeholder: 'Enter required maximum number',
        errorMessage: '',
      },
      {
        type: 'lessThan',
        name: 'Less Than Number',
        value: '',
        placeholder: 'Enter required less than number',
        errorMessage: '',
      },
      {
        type: 'moreThan',
        name: 'More Than Number',
        value: '',
        placeholder: 'Enter required more than number',
        errorMessage: '',
      },
      { type: 'positive', name: 'Ensure Positive', errorMessage: '' },
      { type: 'negative', name: 'Ensure Negative', errorMessage: '' },
    ],
  },
  {
    id: '3',
    value: 'date',
    name: 'Date',
    validations: [
      { type: 'required', name: 'Required', errorMessage: '' },
      {
        type: 'min',
        name: 'Minimum Date',
        value: '',
        placeholder: 'Enter required minimum date',
        errorMessage: '',
      },
      {
        type: 'max',
        name: 'Maximum Date',
        value: '',
        placeholder: 'Enter required maximum date',
        errorMessage: '',
      },
    ],
  },
  {
    id: '4',
    value: 'time',
    name: 'Time',
    validations: [
      { type: 'required', name: 'Required', errorMessage: '' },
      {
        type: 'min',
        name: 'Minimum time',
        value: '',
        placeholder: 'Enter required minimum time',
        errorMessage: '',
      },
      {
        type: 'max',
        name: 'Maximum time',
        value: '',
        placeholder: 'Enter required maximum time',
        errorMessage: '',
      },
    ],
  },
  {
    id: '5',
    value: 'short answer',
    name: 'Short answer',
    validations: [
      { type: 'required', name: 'Required', errorMessage: '' },
      {
        type: 'length',
        name: 'Text length',
        value: '',
        placeholder: 'Enter required length',
        errorMessage: '',
      },
      {
        type: 'min',
        name: 'Min text length',
        value: '',
        placeholder: 'Enter minimum required length',
        errorMessage: '',
      },
      {
        type: 'max',
        name: 'Max text length',
        value: '',
        placeholder: 'Enter maximum required length',
        errorMessage: '',
      },
      {
        type: 'matches',
        name: 'Matches pattern',
        value: '',
        placeholder: 'Enter regex pattern',
        errorMessage: '',
      },
      { type: 'url', name: 'Ensure URL', errorMessage: '' },
      { type: 'uuid', name: 'Ensure UUID', errorMessage: '' },
      { type: 'trim', name: 'Ensure Trimmed', errorMessage: '' },
      { type: 'lowercase', name: 'Ensure Lowercase', errorMessage: '' },
      { type: 'uppercase', name: 'Ensure Uppercase', errorMessage: '' },
    ],
  },
  {
    id: '6',
    value: 'paragraph',
    name: 'Paragraph',
    validations: [
      { type: 'required', name: 'Required', errorMessage: '' },
      {
        type: 'length',
        name: 'Text length',
        value: '',
        placeholder: 'Enter required length',
        errorMessage: '',
      },
      {
        type: 'min',
        name: 'Min text length',
        value: '',
        placeholder: 'Enter minimum required length',
        errorMessage: '',
      },
      {
        type: 'max',
        name: 'Max text length',
        value: '',
        placeholder: 'Enter maximum required length',
        errorMessage: '',
      },
      {
        type: 'matches',
        name: 'Matches pattern',
        value: '',
        placeholder: 'Enter regex pattern',
        errorMessage: '',
      },
      { type: 'url', name: 'Ensure URL', errorMessage: '' },
      { type: 'uuid', name: 'Ensure UUID', errorMessage: '' },
      { type: 'trim', name: 'Ensure Trimmed', errorMessage: '' },
      { type: 'lowercase', name: 'Ensure Lowercase', errorMessage: '' },
      { type: 'uppercase', name: 'Ensure Uppercase', errorMessage: '' },
    ],
  },
  {
    id: '7',
    value: 'multiple choice',
    name: 'Multiple choice',
    validations: [
      { type: 'required', name: 'Required', errorMessage: '' },
      {
        type: 'length',
        name: 'Number of selections',
        value: '',
        placeholder: 'Enter required no. of selections',
        errorMessage: '',
      },
      {
        type: 'min',
        name: 'Min. Number of selections',
        value: '',
        placeholder: 'Enter required minimum no. of selections',
        errorMessage: '',
      },
      {
        type: 'max',
        name: 'Max. Number of selections',
        value: '',
        placeholder: 'Enter required maximum no. of selections',
        errorMessage: '',
      },
    ],
  },
  {
    id: '8',
    value: 'checkboxes',
    name: 'Checkboxes',
    validations: [{ type: 'enforceChecked', name: 'Enforce checked', errorMessage: '' }],
  },
  {
    id: '9',
    value: 'dropdown',
    name: 'Dropdown',
    validations: [{ type: 'required', name: 'Required', errorMessage: '' }],
  },
  {
    id: '10',
    value: 'file upload',
    name: 'File upload',
    validations: [
      { type: 'required', name: 'Required', errorMessage: '' },
      {
        type: 'maxSize',
        name: 'Max file size',
        value: '',
        placeholder: 'Enter max file size in MB. e.g. 10',
        errorMessage: '',
      },
      {
        type: 'fileTypes',
        name: 'File types',
        value: '',
        placeholder: 'Enter accepted file types with comma. e.g. pdf,docx,jpg',
        errorMessage: '',
      },
    ],
  },
  {
    id: '11',
    value: 'currency',
    name: 'Currency',
    validations: [{ type: 'required', name: 'Required', errorMessage: '' }],
  },
  {
    id: '12',
    value: 'email',
    name: 'Email',
    validations: [
      { type: 'required', name: 'Required', errorMessage: '' },
      { type: 'email', name: 'Ensure Email', errorMessage: '' },
    ],
  },
  {
    id: '13',
    value: 'phone',
    name: 'Phone',
    validations: [
      { type: 'required', name: 'Required', errorMessage: '' },
      {
        type: 'length',
        name: 'Phone No. length',
        value: '',
        placeholder: 'Enter required phone no. length',
        errorMessage: '',
      },
      {
        type: 'min',
        name: 'Min. Phone No. length',
        value: '',
        placeholder: 'Enter required minimum phone no. length',
        errorMessage: '',
      },
      {
        type: 'max',
        name: 'Max. Phone No. length',
        value: '',
        placeholder: 'Enter required maximum phone no. length',
        errorMessage: '',
      },
      {
        type: 'matches',
        name: 'Matches pattern',
        value: '',
        placeholder: 'Enter regex pattern',
        errorMessage: '',
      },
    ],
  },
  {
    id: '14',
    value: 'image upload',
    name: 'Image upload',
    validations: [
      { type: 'required', name: 'Required', errorMessage: '' },
      {
        type: 'maxSize',
        name: 'Max file size',
        value: '',
        placeholder: 'Enter max file size in MB. e.g. 10',
        errorMessage: '',
      },
      {
        type: 'fileTypes',
        name: 'File types',
        value: '',
        placeholder: 'Enter accepted file types with comma. e.g. jpg,png,jpeg',
        errorMessage: '',
      },
    ],
  },
  {
    id: '15',
    value: 'description',
    name: 'Description',
    validations: [
      { type: 'required', name: 'Required', errorMessage: '' },
      {
        type: 'length',
        name: 'Text length',
        value: '',
        placeholder: 'Enter required length',
        errorMessage: '',
      },
      {
        type: 'min',
        name: 'Min text length',
        value: '',
        placeholder: 'Enter minimum required length',
        errorMessage: '',
      },
      {
        type: 'max',
        name: 'Max text length',
        value: '',
        placeholder: 'Enter maximum required length',
        errorMessage: '',
      },
      {
        type: 'matches',
        name: 'Matches pattern',
        value: '',
        placeholder: 'Enter regex pattern',
        errorMessage: '',
      },
      { type: 'url', name: 'Ensure URL', errorMessage: '' },
      { type: 'uuid', name: 'Ensure UUID', errorMessage: '' },
      { type: 'trim', name: 'Ensure Trimmed', errorMessage: '' },
      { type: 'lowercase', name: 'Ensure Lowercase', errorMessage: '' },
      { type: 'uppercase', name: 'Ensure Uppercase', errorMessage: '' },
    ],
  },
  {
    id: '16',
    value: 'rating',
    name: 'Rating',
    validations: [
      { type: 'required', name: 'Required', errorMessage: '' },
      {
        type: 'min',
        name: 'Min Rating',
        value: '',
        placeholder: 'Enter minimum required rating',
        errorMessage: '',
      },
      {
        type: 'max',
        name: 'Max Rating',
        value: '',
        placeholder: 'Enter maximum required rating',
        errorMessage: '',
      },
    ],
  },
  {
    id: '17',
    value: 'unique ID',
    name: 'Unique ID',
    validations: [
      { type: 'required', name: 'Required', errorMessage: '' },
      {
        type: 'length',
        name: 'Text length',
        value: '',
        placeholder: 'Enter required length',
        errorMessage: '',
      },
      {
        type: 'min',
        name: 'Min text length',
        value: '',
        placeholder: 'Enter minimum required length',
        errorMessage: '',
      },
      {
        type: 'max',
        name: 'Max text length',
        value: '',
        placeholder: 'Enter maximum required length',
        errorMessage: '',
      },
      {
        type: 'matches',
        name: 'Matches pattern',
        value: '',
        placeholder: 'Enter regex pattern',
        errorMessage: '',
      },
      { type: 'url', name: 'Ensure URL', errorMessage: '' },
      { type: 'uuid', name: 'Ensure UUID', errorMessage: '' },
      { type: 'trim', name: 'Ensure Trimmed', errorMessage: '' },
      { type: 'lowercase', name: 'Ensure Lowercase', errorMessage: '' },
      { type: 'uppercase', name: 'Ensure Uppercase', errorMessage: '' },
    ],
  },
  {
    id: '18',
    value: 'radio',
    name: 'Radio',
    validations: [{ type: 'required', name: 'Required', errorMessage: '' }],
  },
  {
    id: '19',
    value: 'country dropdown',
    name: 'Country Dropdown',
    validations: [{ type: 'required', name: 'Required', errorMessage: '' }],
  },
  {
    id: '20',
    value: 'occupation dropdown',
    name: 'Occupation Dropdown',
    validations: [{ type: 'required', name: 'Required', errorMessage: '' }],
  },
  {
    id: '21',
    value: 'dependent',
    name: 'Dependent',
    validations: [{ type: 'required', name: 'Required', errorMessage: '' }],
  },
];

export enum Role {
  SUPER_ADMIN = 'Super Admin',
  ADMIN_OPS = 'Ops Manager',
  ADMIN_AGENT = 'Ops Executive',
  ACCOUNTANT = 'Accountant',
  CONTENT_MANAGER = 'Content Manager',
}

export const RemoveRolePermission: any = {
  [Role.SUPER_ADMIN]: {
    create: false,
    read: false,
    delete: false,
    update: false,
    // Super Admin keeps full access, including Documitra Reports.
    disableModule: [],
  },
  // Ops Manager — Reports disabled; Transactions → Refund Requests (eligibility step), Rejected Orders and Payment Vouchers only.
  [Role.ADMIN_OPS]: {
    create: false,
    read: false,
    delete: true,
    update: false,
    disableModule: [
      'Documitra Reports',
      'Banner Management',
      'Bucket Management',
      'Contact Info',
      'Become a Partner Info',
      'Partner Services',
      'External Pages',
      'photomitra_Transactions',
      // Keep Transactions parent; hide every child except Refund Requests, Rejected Orders and Payment Vouchers.
      'Photomitra',
      'Documitra',
      'Agent Ledger',
      'Partner Withdraw Request',
      'Users',
      'Partners',
      'SEO Management',
      'Content Management',
      'Service Content',
      'Package Content',
    ],
  },
  // Ops Executive — Documitra Reports & Enquiry Form disabled.
  [Role.ADMIN_AGENT]: {
    create: false,
    read: false,
    delete: false,
    update: false,
    disableModule: [
      'Documitra Reports',
      'Enquiry Form',
      'Home Page',
      'Photomitra Page',
      'Users',
      'Coupon Management',
      'Packages',
      'Services',
      'Photo-Store',
      'Contact Info',
      'Become a Partner Info',
      'Logs & History',
      'User Refferals',
      'Banner Management',
      'Bucket Management',
      'Offer Management',
      'Partner Services',
      'External Pages',
      'Contact Form',
      'Refund Requests',
      'Transactions',
      'Partners',
      'SEO Management',
      'Content Management',
      'Service Content',
      'Package Content',
    ],
  },
  // Accountant — same module access as before; mark-refunded is allowed via API role.
  [Role.ACCOUNTANT]: {
    create: true,
    read: true,
    delete: true,
    update: true,
    disableModule: [
      'Dashboard',
      'Agent Orders',
      'Enquiry Form',
      'External Pages',
      'Coupon Management',
      'Packages',
      'Services',
      'Contact Form',
      'Contact Info',
      'Become a Partner Info',
      'Photo-Store',
      'Photomitra Page',
      'Home Page',
      'Users',
      'Logs & History',
      'User Refferals',
      'Banner Management',
      'Bucket Management',
      'Offer Management',
      'Partner Services',
      'Partners',
      'SEO Management',
      'Content Management',
    ],
  },
  // Content Manager — Dashboard / Agent Orders / Enquiry / Reports disabled;
  // Newsroom Management stays enabled (other Home Page children hidden).
  [Role.CONTENT_MANAGER]: {
    create: false,
    read: false,
    delete: false,
    update: false,
    disableModule: [
      'Dashboard',
      'Agent Orders',
      'Enquiry Form',
      'Documitra Reports',
      'Users',
      'Partners',
      'Documitra Order',
      'Photo Order',
      'Transactions',
      'Coupon Management',
      'Contact Form',
      // Do not disable parent "Home Page" — that would also hide News.
      'Documitra FAQ',
      'Why Documitra',
      'Reviews',
      'How It Works',
      'Offer Management',
      'Banner Management',
      'Homepage Articles',
      'Services Page',
      'Photomitra Page',
      'Photo-Store',
      'Contact Info',
      'Become a Partner Info',
      'Services',
      'Packages',
      'Partner Services',
      'External Pages',
      'Logs & History',
    ],
  },
};

export const reportType: any = {
  '/contact/user-info': 'UserInfo',
  '/contact/become-partner-info': 'BecomePartnerInfo',
  '/application/admin-order': 'DocumitraOrder',
  '/photo-orders/application': 'PhotomitraOrder',
  '/users': 'Users',
  '/photo-orders/transactions-photomitra': 'PhotomitraTransaction',
  '/application/transactions-documitra': 'DocumitraTransaction',
  '/refund-request': 'RefundRequest',
  '/partner-portal/groups': 'PartnerOrder',
};

export const TRANSACTION_DATA_FILTERS = [
  {
    key: 1,
    name: 'Date',
    componentType: 'DATE',
    level: 'date',
  },
  {
    key: 2,
    name: 'Payment Status',
    componentType: 'SELECT',
    level: 'paymentStatus',
    options: documitraPaymentStatusOption,
  },
];

/** Agent Ledger (CMS) — payment filters */
export const AGENT_LEDGER_PAYMENT_STATUS_OPTIONS: StatusType = [
  { id: '1', value: 'payment_confirmation_pending', name: 'Payment Confirmation Pending' },
  { id: '2', value: 'paid', name: 'Paid' },
  { id: '3', value: 'payment_pending', name: 'Payment Pending' },
  { id: '4', value: 'failed', name: 'Payment Unsuccessful' },
  { id: '5', value: 'partial', name: 'Partial Payment Received' },
];

export const AGENT_LEDGER_PAYMENT_METHOD_OPTIONS: StatusType = [
  { id: '1', value: 'stripe', name: 'Stripe' },
  { id: '2', value: 'zelle', name: 'Zelle' },
  { id: '3', value: 'venmo', name: 'Venmo' },
];

export const AGENT_LEDGER_REVIEW_STATUS_OPTIONS: StatusType = [
  { id: '1', value: 'pending', name: 'Pending Review' },
  { id: '2', value: 'accepted', name: 'Accepted' },
  { id: '3', value: 'rejected', name: 'Rejected' },
  { id: '4', value: 'partial', name: 'Partial' },
];

/** Payment Vouchers (CMS) — list filters */
export const PAYMENT_VOUCHER_STATUS_OPTIONS: StatusType = [
  { id: '1', value: 'Generated', name: 'Generated' },
  { id: '2', value: 'Partially Paid', name: 'Partially Paid' },
  { id: '3', value: 'Settled', name: 'Settled' },
  { id: '4', value: 'Cancelled', name: 'Cancelled' },
];

/** Accounting workflow status — maintained from Transactions → Payment Vouchers. */
export const PAYMENT_VOUCHER_ACCOUNTING_STATUS_OPTIONS: StatusType = [
  { id: '1', value: 'Pending', name: 'Pending' },
  { id: '2', value: 'Recorded', name: 'Recorded' },
  { id: '3', value: 'Pending Settlement', name: 'Pending Settlement' },
];

export const PAYMENT_VOUCHER_METHOD_OPTIONS: StatusType = [
  { id: '1', value: 'Zelle', name: 'Zelle' },
  { id: '2', value: 'Venmo', name: 'Venmo' },
  { id: '3', value: 'Stripe', name: 'Stripe' },
  { id: '4', value: 'Bank Transfer', name: 'Bank Transfer' },
];

export const LOGS_FILTER_DATA_MODEL = [
  {
    key: 1,
    name: 'Date',
    componentType: 'DATE',
    level: 'date',
  },
  {
    key: 2,
    name: 'Module Name',
    componentType: 'SELECT',
    level: 'moduleName',
    options: [
      { id: '1', name: 'Admin User', value: 'Admin User' },
      { id: '2', name: 'Documitra User', value: 'Documitra User' },
      { id: '3', name: 'Docunitra Faq', value: 'Docunitra Faq' },
      { id: '4', name: 'Why Documitra', value: 'Why Documitra' },
      { id: '5', name: 'Documitra Reviews', value: 'Documitra Reviews' },
      {
        id: '6',
        name: 'How It Works - Documitra',
        value: 'How It Works - Documitra',
      },
      { id: '7', name: 'Why Photomitra', value: 'Why Photomitra' },
      {
        id: '8',
        name: 'How It Works - Photomitra',
        value: 'How It Works - Photomitra',
      },
      { id: '9', name: 'Taking Photo Steps', value: 'Taking Photo Steps' },
      { id: '10', name: 'Photomitra Faq', value: 'Photomitra Faq' },
      { id: '11', name: 'Photo Size', value: 'Photo Size' },
      { id: '12', name: 'File Type', value: 'File Type' },
      { id: '13', name: 'Plans Page', value: 'Plans Page' },
      { id: '14', name: 'Contact Information', value: 'Contact Information' },
      { id: '15', name: 'Contact Form', value: 'Contact Form' },
      { id: '16', name: 'Services', value: 'Services' },
      { id: '17', name: 'Documents', value: 'Documents' },
      { id: '18', name: 'Features', value: 'Features' },
      { id: '19', name: 'Packages', value: 'Packages' },
      { id: '20', name: 'Questions', value: 'Questions' },
      { id: '21', name: 'Forms', value: 'Forms' },
      { id: '22', name: 'Processes', value: 'Processes' },
      { id: '23', name: 'Steps', value: 'Steps' },
      { id: '25', name: 'Photo Order', value: 'Photo Order' },
      { id: '26', name: 'Documitra Order', value: 'Documitra Order' },
      { id: '27', name: 'Coupon Management', value: 'Coupon Management' },
      { id: '28', name: 'Terms Page', value: 'Terms Page' },
      { id: '29', name: 'Conditions Page', value: 'Conditions Page' },
      { id: '30', name: 'About Us Team', value: 'About Us Team' },
      { id: '32', name: 'Related Article', value: 'Related Article' },
    ],
  },
  {
    key: 3,
    name: 'Action Type',
    componentType: 'SELECT',
    level: 'actionType',
    options: [
      { id: '1', value: 'created', name: 'Created' },
      { id: '2', value: 'updated', name: 'Updated' },
      { id: '3', value: 'deleted', name: 'Deleted' },
    ],
  },
];

export const DOCUMITRA_ORDER_DATA_MODEL = [
  {
    key: 1,
    name: 'DOB',
    componentType: 'DOB',
    level: 'dateOfBirth',
  },
  {
    key: 2,
    name: 'Passport Number',
    componentType: 'INPUT',
    level: 'passportNumber',
  },
];

export const DOCUMITRA_FINAL_EMAIL_TRACKING_DATA_MODEL = [
  {
    key: 1,
    name: 'Tracking ID',
    componentType: 'INPUT',
    level: 'finalEmailTrackingDetails.trackingId',
  },
  {
    key: 2,
    name: 'Carrier Name',
    componentType: 'INPUT',
    level: 'finalEmailTrackingDetails.carrierName',
  },
  {
    key: 3,
    name: 'Tracking Link',
    componentType: 'INPUT',
    level: 'finalEmailTrackingDetails.trackingLink',
  },
];

export const REFUND_STATUS = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  REFUNDED: 'REFUNDED',
} as const;

export const REFUND_STATUS_OPTIONS = [
  { id: '1', value: REFUND_STATUS.PENDING, name: 'Pending' },
  { id: '2', value: REFUND_STATUS.APPROVED, name: 'Approved' },
  { id: '3', value: REFUND_STATUS.REJECTED, name: 'Rejected' },
  { id: '4', value: REFUND_STATUS.REFUNDED, name: 'Refunded' },
];

export const REFUND_FEE_TYPE_OPTIONS = [
  {
    id: '1',
    value: 'GOVT_AND_COURIER',
    name: 'Application Charges',
  },
  {
    id: '2',
    value: 'DOCUMITRA_FEE',
    name: 'Documitra Fee',
  },
];

/** "Application Charges" / "Documitra Fee" for a refund's refundType. */
export const getRefundFeeTypeLabel = (refundType?: string | null): string =>
  REFUND_FEE_TYPE_OPTIONS.find(option => option.value === refundType)?.name || refundType || '--';

/** Payment methods used when a client submits a refund request */
export const REFUND_REQUEST_PAYMENT_METHOD_OPTIONS = [
  { id: '1', value: 'Stripe', name: 'Stripe' },
  { id: '2', value: 'Credit/ Debit Card', name: 'Credit/ Debit Card' },
  { id: '3', value: 'Zelle', name: 'Zelle' },
  { id: '4', value: 'Venmo', name: 'Venmo' },
];

export const REFUND_METHODS = {
  STRIPE: 'Stripe',
  CREDIT_DEBIT_CARD: 'Credit/ Debit Card',
  ZELLE: 'Zelle',
  VENMO: 'Venmo',
} as const;

export const REFUND_METHOD_OPTIONS = [
  { id: '1', value: REFUND_METHODS.STRIPE, name: 'Stripe' },
  { id: '2', value: REFUND_METHODS.CREDIT_DEBIT_CARD, name: 'Credit/ Debit Card' },
  { id: '3', value: REFUND_METHODS.ZELLE, name: 'Zelle' },
  { id: '4', value: REFUND_METHODS.VENMO, name: 'Venmo' },
];
